import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Group, Table, Text } from '@mantine/core';
import { IconEdit, IconTrash } from '@tabler/icons-react';

import { useRemovePaymentProvider } from '../../api/removePaymentProvider';
import { paymentProviderTypes } from '../../types';
import { EditModal } from '../EditModal';

import { ConfirmModal } from '@/components/Modals/Confirm';
import { Departments } from '@/types';

type BodyRowProps = {
  department: Departments;
  paymentProvider: paymentProviderTypes.PaymentProvider;
};

export const BodyRow = ({ department, paymentProvider }: BodyRowProps) => {
  const removePaymentProvider = useRemovePaymentProvider({ department });
  const { _id, name, key, block } = paymentProvider;

  return (
    <Table.Tr>
      <Table.Td>
        <Text size="sm">{name}</Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{key}</Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{block}</Text>
      </Table.Td>
      <Table.Td>
        <Group>
          <ActionIcon
            variant="filled"
            radius="md"
            onClick={() =>
              NiceModal.show(EditModal, {
                paymentProviderId: _id,
                initialValues: { name, key, block, department },
              })
            }
          >
            <IconEdit size={16} />
          </ActionIcon>
          <ActionIcon
            variant="filled"
            radius="md"
            color="red"
            onClick={() =>
              NiceModal.show(ConfirmModal, {
                title: `Remove payment provider (${name})?`,
                onSuccess: () => removePaymentProvider.mutate({ _id }),
              })
            }
          >
            <IconTrash size={16} />
          </ActionIcon>
        </Group>
      </Table.Td>
    </Table.Tr>
  );
};
